import { useCallback } from 'react'
import { getPublicEnrollmentStateRequest } from '@/api/enrollment-api'
import type { ApplyHydrationFn } from '../../types'

type UseEnrollmentSessionHydrationArgs = {
  applyHydration: ApplyHydrationFn
  enrollmentSessionToken: string | null
  shouldSyncHydratedStep: boolean
}

export function useEnrollmentSessionHydration({
  applyHydration,
  enrollmentSessionToken,
  shouldSyncHydratedStep
}: UseEnrollmentSessionHydrationArgs) {
  return useCallback(
    async (syncStep = shouldSyncHydratedStep) => {
      if (!enrollmentSessionToken) {
        return null
      }

      const enrollment = await getPublicEnrollmentStateRequest(enrollmentSessionToken)
      applyHydration({ enrollment, syncStep })
      return enrollment
    },
    [applyHydration, enrollmentSessionToken, shouldSyncHydratedStep]
  )
}
